module.exports = __webpack_public_path__ + "img/science.747aaf52.png";